/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type CommunicationsStatusPageEntrypointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const communicationsStatusPageEntrypoint: EntryPoint<
	CommunicationsStatusPageEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<CommunicationsStatusPageEntrypointComponent>(
		/* webpackChunkName: "async-communications-status-page-entrypoint" */ './ui/StatusPage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => {
		return {};
	},
});
